import { render, staticRenderFns } from "./pi-home-card.vue?vue&type=template&id=31d3c8e6&"
import script from "./pi-home-card.vue?vue&type=script&lang=ts&"
export * from "./pi-home-card.vue?vue&type=script&lang=ts&"
import style0 from "./pi-home-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports